import type { CardProps } from 'src/notifications/cardTypes';
import { formatShortDate, formatTime } from 'src/utils/dateFormatting';
import NotificationCardShell from '../NotificationCardShell';
import NotificationDetailRow from '../NotificationDetailRow';
import NotificationLinkButton from '../NotificationLinkButton';

export default function MeetingWithoutNoteCard({
  notification,
  payload,
  onClose,
}: CardProps<'MEETING_WITHOUT_NOTE'>) {
  return (
    <NotificationCardShell
      notification={notification}
      title="Meeting note due"
      body="A past meeting still has no note."
      clientId={payload.client_id ?? undefined}
      details={
        <>
          {payload.meeting_title && (
            <NotificationDetailRow label="Meeting" value={payload.meeting_title} />
          )}
          <NotificationDetailRow label="Date" value={formatShortDate(payload.meeting_date)} />
          <NotificationDetailRow
            label="Time"
            value={`${formatTime(payload.meeting_date)} to ${formatTime(payload.meeting_end)}`}
          />
        </>
      }
      actions={
        <NotificationLinkButton
          primary
          to={`/meetings/${payload.calendar_event_id}/meeting-note`}
          onClose={onClose}
        >
          View
        </NotificationLinkButton>
      }
    />
  );
}
